// App.js - Aufgeräumt und refactored
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { auth, ALLOWED_DOMAIN } from './constants/firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';

import Loading from './views/Loading';
import Header from './views/Header';
import Start from './views/Start';
import ToolsPage from './views/ToolsPage';
import Login from './views/Login';
import SubmitTool from './views/SubmitTool';

import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    // Listen for auth state changes
    const unsubscribe = onAuthStateChanged(
      auth,
      // Success callback
      async (currentUser) => {
        console.log('Auth state changed:', currentUser?.email);
        
        if (currentUser) {
          // User is signed in, check domain
          if (currentUser.email.endsWith(`@${ALLOWED_DOMAIN}`)) {
            // Verify the token is still valid by forcing a refresh
            try {
              await currentUser.getIdToken(true); // Force refresh
              setUser(currentUser);
            } catch (tokenError) {
              // Token refresh failed - user's access was revoked
              console.error('Token refresh failed:', tokenError);
              await signOut(auth);
              setUser(null);
            }
          } else {
            // Wrong domain
            await signOut(auth);
            setUser(null);
          }
        } else {
          // No user signed in
          setUser(null);
        }
        
        setAuthChecked(true);
        setLoading(false);
      },
      // Error callback
      (authError) => {
        console.error('Auth error:', authError);
        setLoading(false);
        setAuthChecked(true);
      }
    );

    return () => unsubscribe();
  }, []);

  // Show loading spinner while checking auth state
  if (!authChecked || loading) {
    return (
      <Loading />
    );
  }

  // Show login screen if no user
  if (!user) {
    return <Login />;
  }

  // User is authenticated, show app
  return (
    <BrowserRouter>
      <div className="min-h-screen text-white bg-gray-950">
        <Header />
        <Routes>
          <Route path="/" element={<Start />} />
          <Route path="/submit" element={<SubmitTool />} />
          <Route path="/tools/:sectionId" element={<ToolsPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;